module.exports = __webpack_public_path__ + "img/dink-white-bedroom-1.9be69ea7.jpeg";